import React from 'react';
import { ArrowDown, Github, Linkedin, Mail, Download } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="min-h-screen flex flex-col justify-center relative pt-20 grid-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
        <div className="py-20 lg:py-32">
          {/* Label */}
          <div className="mb-8">
            <span className="label-text inline-flex items-center gap-2">
              <span className="w-2 h-2 bg-[#38FF62] inline-block animate-pulse"></span>
              {personalInfo.title}
            </span>
          </div>

          {/* Main Title */}
          <h1 className="hero-title mb-8">
            <span className="block">Krishnanshu</span>
            <span className="block text-[#38FF62]">Bhadauria</span>
          </h1>

          {/* Tagline */}
          <p className="font-body text-xl md:text-2xl lg:text-3xl text-[rgba(35,35,35,0.7)] max-w-2xl mb-12 leading-relaxed">
            {personalInfo.tagline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-16">
            <a href="#projects" className="btn-accent inline-flex items-center gap-2">
              View Projects
              <ArrowDown className="w-4 h-4" />
            </a>
            <a href="#contact" className="btn-primary inline-flex items-center gap-2">
              Get In Touch
            </a>
            <a 
              href={personalInfo.resumeUrl} 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2 hover:bg-[#38FF62] hover:border-[#38FF62] hover:text-[#232323] transition-all"
            >
              <Download className="w-4 h-4" />
              Resume
            </a>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 border border-[rgba(35,35,35,0.2)] hover:border-[#232323] hover:bg-[rgba(35,35,35,0.05)] transition-all"
            >
              <Github className="w-5 h-5" />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 border border-[rgba(35,35,35,0.2)] hover:border-[#232323] hover:bg-[rgba(35,35,35,0.05)] transition-all"
            >
              <Linkedin className="w-5 h-5" />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="p-3 border border-[rgba(35,35,35,0.2)] hover:border-[#232323] hover:bg-[rgba(35,35,35,0.05)] transition-all"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-[rgba(35,35,35,0.4)]" />
      </div>
    </section>
  );
};

export default Hero;